<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div
      class="spnod-admin__form--container container mx-0 w-100 h-100"
      :class="isMobile ? 'px-0' : 'px-3'">
      <div id="login-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
        <h3 class="h3 mb-4">Unsubscribe</h3>
        <div v-if="unsubscribed === false" class="d-flex flex-column align-items-center">
          <p class="mb-3">Please be aware by unsubscribing from emails, you will not be notified of unread messages moving forward. If you decide to unsubscribe, it will be your responsibility to login and check for unread messages within the app.</p>
          <b-button
            type="submit"
            class="spnod-admin__form--button"
            size="sm"
            v-on:click.stop.prevent="unsubscribe()">
            Unsubscribe
          </b-button>
        </div>
        <div v-if="unsubscribed === true" class="d-flex flex-column align-items-center">
          <p class="mb-3">You have been unsubscribed. Please remember to check back in for new messages from time to time.</p>
          <router-link :to="{ name: 'messages' }" class="text-center">
            View Messages
          </router-link>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Unsubscribe',
  data() {
    return {
      unsubscribed: false
    }
  },
  computed: {
    ...mapGetters([
      'loggedIn'
    ]),
    isMobile() { return window.innerWidth <= 768 }
  },
  methods: {
    ...mapActions([
      'doUnsubscribe'
    ]),
    async  unsubscribe() {
      await this.doUnsubscribe()
      this.unsubscribed = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/Unsubscribe.vue?40818fa7